import { useEffect, useRef, useState } from 'react';
import { Language, useT, type Locale } from '../i18n';

export function WechatNotice() {
  const [preferences] = useState(() => {
    const fallback = { locale: 'zh' as Locale, theme: matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' };
    try {
      return { locale: (localStorage.getItem('mixonline:locale') === 'en' ? 'en' : 'zh') as Locale,
        theme: localStorage.getItem('mixonline:theme') || fallback.theme };
    } catch { return fallback; }
  });
  useEffect(() => {
    document.documentElement.lang = preferences.locale === 'zh' ? 'zh-CN' : 'en';
    document.documentElement.dataset.theme = preferences.theme;
  }, [preferences]);
  return <Language locale={preferences.locale}><WechatGuide /></Language>;
}

function WechatGuide() {
  const t = useT();
  const link = location.href;
  const input = useRef<HTMLInputElement>(null);
  const [status, setStatus] = useState('');
  async function copyLink() {
    try {
      await navigator.clipboard.writeText(link);
      setStatus('链接已复制');
    } catch {
      input.current?.focus();
      input.current?.select();
      setStatus('无法复制，请长按链接手动复制。');
    }
  }
  return <main className="wechat-page"><section className="panel wechat-notice" aria-labelledby="wechat-heading">
    <div className="brand"><span className="logo" aria-hidden="true"><i /><i /><i /></span>MixOnline</div>
    <h1 id="wechat-heading">{t('请在浏览器中打开')}</h1>
    <p>{t('微信内暂不支持使用。请点击右上角 ···，选择在浏览器中打开。')}</p>
    <p className="muted">{t('也可以复制链接，粘贴到 Safari、Chrome 等浏览器中打开。')}</p>
    <label htmlFor="wechat-link" className="muted">{t('当前页面链接')}</label>
    <input ref={input} id="wechat-link" readOnly value={link} onFocus={event => event.currentTarget.select()} />
    <button className="primary" type="button" onClick={() => void copyLink()}>{t('复制链接')}</button>
    <p className="muted" role="status">{status ? t(status) : ''}</p>
  </section></main>;
}
